import createIcon from '../../createIcon';

/**
 * @component @name FlashlightOn
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMkg2VjVIMThWMloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik02IDdWOEw4IDExVjIySDE2VjExTDE4IDhWN0g2Wk0xMiAxNS41QzExLjE3IDE1LjUgMTAuNSAxNC44MyAxMC41IDE0QzEwLjUgMTMuMTcgMTEuMTcgMTIuNSAxMiAxMi41QzEyLjgzIDEyLjUgMTMuNSAxMy4xNyAxMy41IDE0QzEzLjUgMTQuODMgMTIuODMgMTUuNSAxMiAxNS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FlashlightOn = createIcon('FlashlightOn', [
  ['path', { d: 'M18 2H6V5H18V2Z', key: '17ngt5' }],
  [
    'path',
    {
      d: 'M6 7V8L8 11V22H16V11L18 8V7H6ZM12 15.5C11.17 15.5 10.5 14.83 10.5 14C10.5 13.17 11.17 12.5 12 12.5C12.83 12.5 13.5 13.17 13.5 14C13.5 14.83 12.83 15.5 12 15.5Z',
      key: 'edvd56',
    },
  ],
]);

export default FlashlightOn;
